



















import { Component, Prop, Vue } from 'vue-property-decorator'
@Component<VtTabbedApp>({})
export default class VtTabbedApp extends Vue{
  @Prop({default:112,type:Number}) topAppBarHeight!:number
}
